module.exports = __webpack_public_path__ + "img/trial_code.20dc5bd1.jpg";